import { Component, OnInit } from '@angular/core';

import { BaseComponent } from '../../base/base.component';

import { WizardService } from '../../../services/wizard/wizard.service';
import { EventService } from '../../../services/event/event.service';
import { ErrorService } from '../../../services/error/error.service';

//: Special screen for External On-behalf meetings to determine the order of invitations
@Component({
    selector: 'wizard-external-onbehalf',
    templateUrl: './external-on-behalf.component.html',
    styleUrls: ['../../form-styles.scss']
})
export class ExternalOnBehalfComponent extends BaseComponent implements OnInit {
    public selectedContactId = '';

    constructor(
        public wizardService: WizardService,
        private errorService: ErrorService,
        private eventService: EventService
    ) {
        super();
    }

    ngOnInit() {
        this.eventService.isNextDisabled = true;
        if (this.wizardService.selection.length === 1) {
            this.errorService.setError('wizard-external-on-behalf-insufficient-invitees');
        }
    }

    onSelect(contactId: string) {
        this.selectedContactId = contactId;
        if (this.wizardService.selection.length !== 1) {
            this.eventService.isNextDisabled = false;
        }
        this.wizardService.sortItemToStartOfSelection(contactId);
    }
}
